// extracted by mini-css-extract-plugin
module.exports = {"answer":"virtualAssistantFinalStepForm_answer__1WPYa","agreementContainer":"virtualAssistantFinalStepForm_agreementContainer__tB6sP"};
    if(module.hot) {
      // 1790670291218
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  